export * from '@/components/schemas/captainChallenge.schema';
